export default __webpack_public_path__ + "static/media/c002-PPII-14.74d52309.svg";